import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const EUBanner = () => {
  const [open, setOpen] = useState(true);

  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          key="eu-banner"
          initial={false}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
          className="relative w-full overflow-hidden bg-white"
          data-testid="eu-banner"
        >
          <a
            href="https://mfe.gov.ro/pnrr/"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
            aria-label="Fonduri europene – Planul Național de Redresare și Reziliență"
          >
            <img
              src="/fonduri-europene.jpeg"
              alt="Finanțat de Uniunea Europeană – NextGenerationEU, Guvernul României, Planul Național de Redresare și Reziliență"
              className="w-full h-auto object-contain"
            />
          </a>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
            aria-label="Închide bannerul"
            data-testid="eu-banner-close"
            className="absolute top-1/2 -translate-y-1/2 right-2 sm:right-4 flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-full bg-white/90 text-ink shadow-subtle ring-1 ring-black/10 hover:bg-white hover:text-brand focus:outline-none focus:ring-2 focus:ring-brand transition-colors duration-200"
          >
            <X className="h-4 w-4 sm:h-5 sm:w-5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
